<template>
  <el-dialog
    title="新拜访"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
    @open="opened"
    :close-on-click-modal="false"
  >
    <el-form
      :model="model"
      :rules="formRules"
      ref="form"
      label-width="110px"
      size="small"
    >
      <el-form-item
        label="客户"
        class="text-gray"
        v-if="model.customer_name && model.customer_name.length > 0"
      >
        <span>{{ model.customer_name }}</span>
      </el-form-item>
      <el-form-item label="拜访类型" prop="type">
        <el-select
          size="small"
          v-model="model.type"
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="item in followupTypes"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="model.type == 2" label="报价单" prop="quotation_id">
        <el-select
          style="width: 100%"
          size="small"
          v-model="model.quotation_id"
          placeholder="请选择"
        >
          <el-option
            v-for="item in quotations"
            :key="item.number"
            :label="item.number"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="沟通内容" prop="content">
        <el-input
          size="small"
          v-model="model.content"
          placeholder="请输入沟通内容"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 10 }"
          maxlength="1000"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="费用">
        <el-input
          style="width: 100%"
          size="small"
          v-model="model.amount"
          placeholder="请输入本次拜访产生的费用"
        ></el-input>
      </el-form-item>
      <el-form-item label="拜访时间" prop="date">
        <el-date-picker
          style="width: 100%"
          size="small"
          v-model="model.date"
          type="date"
          placeholder="选择日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="本次联系人" prop="customer_contact_id">
        <div class="flex-row-between" style="width: 100%">
          <el-select
            size="small"
            v-model="model.customer_contact_id"
            placeholder="请选择本次联系人"
            style="width: 240px"
          >
            <el-option
              v-for="item in contacts"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-button
            class="ml-10 mobile-ml-0"
            type="primary"
            size="small"
            plain
            icon="el-icon-plus"
            @click="startCustomerContactFormer"
            >新联系人</el-button
          >
        </div>
      </el-form-item>
      <el-form-item label="图片" prop="name_plate">
        <div>
          <viewer class="viewer" ref="viewer">
            <template slot-scope="scope">
              <div
                v-for="(pic, index) in model.pics"
                :key="index"
                class="flex-row-between"
              >
                <auth-img
                  tag="el-image"
                  style="max-width: 30px; max-height: 30px"
                  :src="pic"
                  :preview-src-list="model.pics"
                />
                <el-button
                  size="mini"
                  type="text"
                  icon="el-icon-close"
                  @click="handleRemove(index)"
                  >删除</el-button
                >
              </div>
            </template>
          </viewer>
        </div>
        <el-upload
          class="avatar-uploader"
          :action="uploadUrl"
          :limit="5"
          accept="image/*"
          ref="uploader"
          :show-file-list="false"
          :headers="uploadHeader"
          :on-success="handleSuccess"
          :on-error="handleUploadError"
          :before-upload="beforeUpload"
        >
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="下次拜访时间">
        <el-date-picker
          style="width: 100%"
          size="small"
          v-model="model.next_date"
          type="date"
          placeholder="选择日期"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </span>
    <customer-contact-former
      :model="customerContactForm"
      :show.sync="createCustomerContactFormVisible"
      :inner="true"
      @created="createdCustomerContact"
    ></customer-contact-former>

    <CustomConfig
      v-if="model.type == 1 && visible"
      :customerid="model.customer_id"
    ></CustomConfig>
  </el-dialog>
</template>

<script>
import {
  createCustomerFollowup,
  quotationList,
  customerContactList,
} from '../service/getData'
import { CustomerFollowupTypes } from '@/config/global'
import CustomerContactFormer from '@/components/customer_contact'
import {
  urlPerfix,
  host,
  thumbnailImagePath,
  originImagePath,
} from '@/config/env'
import store from '@/store/store'

export default {
  components: { CustomerContactFormer },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
    model() {
      if (this.model.id > 0) {
        this.model.area = [
          this.model.province,
          this.model.city,
          this.model.county,
        ]
      }
    },
    'model.type': function (newv) {
      if (newv == 2) {
        if (this.quotations.length == 0) {
          this.requestQuotationList()
        }
      }
    },
  },
  data() {
    return {
      host,
      thumbnailImagePath,
      originImagePath,
      uploadUrl: urlPerfix + '/images/upload',
      uploadHeader: { Token: store.state.userInfo.token },
      visible: this.show,
      quotationError: null,
      createCustomerContactFormVisible: false,
      customerContactForm: null,
      formRules: {
        type: [
          { required: true, message: '请选择拜访类型', trigger: 'change' },
        ],
        customer_contact_id: [
          { required: true, message: '请选择联系人', trigger: 'change' },
        ],
        quotation_id: [
          { required: true, message: '请选择报价单', trigger: 'change' },
        ],
        content: [
          { required: true, message: '请填入拜访内容', trigger: 'blur' },
          {
            min: 1,
            max: 1000,
            message: '长度在 1 到 1000 个字',
            trigger: 'blur',
          },
        ],
        date: [
          {
            type: 'date',
            required: true,
            message: '请选择拜访日期',
            trigger: 'change',
          },
        ],
      },
      quotations: [],
      contacts: [],
      customers: [],
      followupTypes: CustomerFollowupTypes,
    }
  },
  methods: {
    async requestQuotationList() {
      if (!this.model.customer_id || this.model.customer_id == 0) {
        return
      }
      let data = {
        page: 0,
        size: 1000,
        customer_id: this.model.customer_id,
      }
      let res = await quotationList(data)
      if (res.code == 0) {
        this.quotations = res.data.list
      }
    },
    opened() {
      if (!this.contacts || this.contacts.length == 0) {
        this.requestCustomerContactList()
        this.$nextTick(() => {
          this.$refs.uploader.clearFiles()
        })
      }
    },
    startCustomerContactFormer() {
      this.customerContactForm = {
        customer_id: this.model.customer_id,
        name: '',
        duty: '',
        mobile: '',
        email: '',
      }
      this.createCustomerContactFormVisible = true
    },
    createdCustomerContact(contact) {
      this.contacts.unshift(contact)
      this.model.customer_contact_id = contact.id
    },
    async requestCustomerContactList() {
      if (!this.model.customer_id || this.model.customer_id == 0) {
        return
      }

      let res = await customerContactList({
        customer_id: this.model.customer_id,
      })
      this.contacts = res.data.list
      if (this.contacts.length == 1) {
        this.model.customer_contact_id = this.contacts[0].id
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.model.amount = parseFloat(this.model.amount) || 0
          if (this.model.id > 0) {
          } else {
            let res = await createCustomerFollowup(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleSuccess(res, file) {
      if (res.code == 0) {
        this.model.pics.push(res.data)
      }
    },
    handleUploadError(err) {
      this.$message({
        message: '上传失败，请重试',
        type: 'error',
        center: true,
      })
    },
    beforeUpload(file) {
      const isLimitSize = file.size / 1024 / 1024 < this.uploadLimitSize.image
      if (!isLimitSize) {
        this.$message.error(`文件大小不能超过 ${this.uploadLimitSize.image}MB!`)
      }
      return isLimitSize
    },
    handleRemove(index) {
      this.model.pics.splice(index, 1)
    },
  },
}
</script>